import BaseMystery from '../BaseMystery'

const FifthJoyfulMystery = () => {
	const imagesList = [
		"https://www.wga.hu/art/b/bonifaci/christ_d.jpg",
		"https://www.wga.hu/art/s/steen/page1/z_christ.jpg",
		"https://www.wga.hu/art/b/bramer/1/christ_d.jpg",
		"https://www.wga.hu/art/d/durer/1/05/07docto.jpg",
		"https://www.wga.hu/art/g/giotto/assisi/lower/ceiling/08christ.jpg",
		"https://www.wga.hu/art/g/giotto/padova/3christ/chris06.jpg",
		"https://www.wga.hu/art/h/hondius/christdo.jpg",
		"https://www.wga.hu/art/p/pinturic/baglioni/2doctor.jpg",
		"https://www.wga.hu/art/p/pourbus/frans_e/christ_d.jpg",
		"https://www.wga.hu/art/s/serodine/christ_e.jpg",
		"https://www.wga.hu/art/s/serodine/christ_d.jpg",
	];

	const scriptureQuote = "And he said to them, \"Why were you looking for me? Did you not know that I must be in my Father's house?\" But they did not understand what he said to them.";
	const scriptureCitation = "Luke 2:49-50 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=Luke%202%3A41-52&version=NABRE";

	return (
		<BaseMystery titleText="The Finding of Jesus in the Temple"
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={false} />
	);
};

export default FifthJoyfulMystery;